/* This is a generated file. Do not edit manually. */
import React from 'react';
import PropTypes from 'prop-types';
import iconSizes from '../../iconSizes';

/**
 * ContactsIcon
 */
export default class ContactsIcon extends React.Component {
  static propTypes = {
    /** The size of the icon */
    size: PropTypes.oneOf(['s', 'm', 'l', 'xl']),
    /** The color of the icon */
    color: PropTypes.string.isRequired
  };

  static defaultProps = {
    size: 'm',
    color: 'black'
  };

  render() {
    const { size: sizeProp, color } = this.props;
    const size = correctButtonSize(sizeProp);
    return (
      <svg
        focusable="false"
        xmlns="http://www.w3.org/2000/svg"
        viewBox={'0 0 32 32'}
        style={{ width: iconSizes[size], height: iconSizes[size] }}
      >
        <g style={{ fill: color }}>
          <svg viewBox="0 0 24 24"><path d="M19 1a3 3 0 013 3v16a3 3 0 01-3 3H6a3 3 0 01-3-3v-1a1 1 0 010-2v-2a1 1 0 01-.117-1.993L3 13v-2a1 1 0 01-.117-1.993L3 9V7a1 1 0 01-.117-1.993L3 5V4a3 3 0 013-3h13zm0 2H6a1 1 0 00-1 1v1a1 1 0 01.117 1.993L5 7v2a1 1 0 01.117 1.993L5 11v2a1 1 0 01.117 1.993L5 15v2a1 1 0 010 2v1a1 1 0 001 1h13a1 1 0 001-1V4a1 1 0 00-1-1zm-5 10a4 4 0 014 4 1 1 0 01-2 0 2 2 0 00-1.85-1.995L14 15h-2a2 2 0 00-2 2 1 1 0 01-2 0 4 4 0 013.8-3.995L12 13h2zm-1-7a3 3 0 110 6 3 3 0 010-6zm0 2a1 1 0 100 2 1 1 0 000-2z" fillRule="nonzero"/></svg>
        </g>
      </svg>
    );
  }
}

/* corrects deprecated api, can be removed in future release */
function correctButtonSize(size) {
  switch (size) {
    case 'medium':
      return 'm';
    case 'small':
      return 's';
    case 'large':
      return 'l';
    case 'xlarge':
      return 'xl';
    default:
      return size;
  }
}

